import { React, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import { useGeoState } from '../../../../components/GeoProvider'
import LinkButton from '../../../../components/LinkButton'
import Tag from '../../../../components/Tag'
import statesMap from '../../../../utils/stateMap'
import getVectorImage from '../../../../utils/getVectorImage'
import styles from './CbsaStats.module.scss'
// import statStyles from './CbsaStat.module.scss'

//import styles from './SideTableStyles.module.scss'
import statStyles from './SideTableStyles.module.scss'

import Tooltip from '../../../../components/Tooltip'
import Content from '../../../../components/Content'

const StateStat = ({ state, chartRef, mapOptions, toggleEnabled }) => {
  const history = useHistory()
  const changePercentage = parseFloat(state.change_percentage)
  const forecastValue = parseFloat(state.forecast_value)
  const isChanged = parseFloat(state.change_percentage) > 0 ? true : false
  const valueStr = changePercentage.toFixed(2)
  const needsPad = parseFloat(valueStr) < 10 // single digit before decimal
  const padded = (needsPad ? '\u2007' : '') + valueStr // figure space

  const handleMouseOver = (element) => {    
    let chartCurrent = chartRef.current.chart
    if (chartCurrent !== undefined && chartCurrent !== null) {
      const identifier = element.attributes['geo_id'].value     
      const point = chartCurrent.series[0].points.find((point) =>  point.geoid === identifier)              
      point && chartCurrent.tooltip.refresh(point)         
    }
  }

  return (
    // <div className={statStyles.base}>
    //   {/* State column */}
    //   <div className={statStyles.columnState} title={state.name}>
    //     <LinkButton
    //       className={statStyles.button}
    //       onMouseOver={(e) => handleMouseOver(e.target)}
    //       onClick={() => {
    //         toggleEnabled
    //           ? history.push(`/FluStateDashboard/STATE/${state.identifier}`)
    //           : history.push(`/forecasts/Flumap#state-${state.identifier}`)
    //       }}
    //       title={state.name}
    //       parent={state.parent}
    //       geo_id={state.identifier}
    //     >
    //       {state.name.length > 15
    //         ? state.name.substring(0, 15) + '...'
    //         : state.name}{' '}
    //       ({state.identifier})
    //     </LinkButton>
    //   </div>

    //   {/* Rate column */}
    //   <div className={statStyles.columnRate}>{forecastValue.toFixed(3)}</div>

    //   {/* Change column */}
    //   <div className={statStyles.columnChange}>
    //     <span className={statStyles.changeIcon}>
    //       {getVectorImage(isChanged)}
    //     </span>
    //     <span
    //       className={isChanged ? styles.percentageRed : styles.percentageGreen}
    //     >
    //       {Math.abs(padded)}%
    //     </span>
    //   </div>
    // </div>
 
    <div style={{ display: 'flex' }} className={statStyles.Layout}>
      <div
        style={{
          width: '45%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          marginLeft:'15px',
        }}
        title={state.statename}
      >
        <LinkButton
          onMouseOver={(e) => handleMouseOver(e.target)}
         // onMouseOut={() => handleMouseOut()}
          className={statStyles.btn}
          onClick={() => {          
            toggleEnabled
              ? history.push(`/FluStateDashboard/STATE/${state.identifier}`)
              : history.push(`/forecasts/Flumap#state-${state.identifier}`)
          }}
          data-title={state.name}
          title={state.name}
          geo_id={state.identifier}
          geo_parent={state.parent}
        >
          {state.name}
        </LinkButton>
      </div>
      <div className={statStyles.columnRate}>{forecastValue.toFixed(3)}</div>
      <div className={statStyles.columnDays}>
        <span> {getVectorImage(isChanged)} </span>
        <span
          className={
            isChanged ? statStyles.percentageRed : statStyles.percentageGreen
          }
        >
          {' '}
          {Math.abs(padded)}%
        </span>
      </div>
    </div>


  )
}

const StateStats = ({ stateData, chartRef, mapOptions, toggleEnabled }) => {
  const aboutText =
    'The Prediction Interval Accuracy is defined in terms of how often the forecasted prediction interval contains the true Actual value (Last Flu Season).'
  const { displayDate, searchFilter, setSearchFilter } = useGeoState()
  const [getFilter, setfilter] = useState('down')

  function sortStatesByForecastValue(obj, direction = 'asc') {
    if (!obj || typeof obj !== 'object') return obj

    // Split entries into metadata and state-code entries
    const entries = Object.entries(obj)

    // Heuristic: state codes are two uppercase letters (AK, AL, ...).
    // Adjust if your keys differ (e.g., 'PR', 'DC' are still matched).
    const isStateCode = (key) => /^[A-Z]{2}$/.test(key)

    const metaEntries = []
    const stateEntries = []
    const nonNumericStateEntries = [] // fallback bucket (missing/invalid forecast_value)

    for (const [key, value] of entries) {
      if (!isStateCode(key)) {
        metaEntries.push([key, value])
        continue
      }

      const fv = value?.forecast_value
      if (typeof fv === 'number' && Number.isFinite(fv)) {
        stateEntries.push([key, value])
      } else {
        nonNumericStateEntries.push([key, value])
      }
    }

    // Sort by forecast_value
    stateEntries.sort((a, b) => {
      const av = a[1].forecast_value
      const bv = b[1].forecast_value
      return direction === 'desc' ? bv - av : av - bv
    })

    // Rebuild a NEW object in the desired order:
    // 1) metadata (original insertion order)
    // 2) sorted states
    // 3) any states without numeric forecast_value (kept at the end, original order)
    const sortedObj = Object.fromEntries([
      ...metaEntries,
      ...stateEntries,
      ...nonNumericStateEntries,
    ])

    return sortedObj
  }

  const sortBy = (action) => {
    const statesObj = stateData[displayDate]
    if (action === 'up') {
      setfilter('down')
      // stateData[displayDate].sort((a, b) => b.datavalue - a.datavalue)
      stateData[displayDate] = sortStatesByForecastValue(statesObj, 'asc')
    } else if (action === 'down') {
      setfilter('up')
      //stateData[displayDate].sort((a, b) => a.datavalue - b.datavalue)
      stateData[displayDate] = sortStatesByForecastValue(statesObj, 'desc')
    }
  }
  const inputRef = useRef(false)

  let isCancelled = useRef(false)
  const [btnSearchLocation, setBtnSearchLocation] = useState(false)
  const states = statesMap()
  const stateDataForDisplayDate = Object.entries(stateData[displayDate])
  // const stateDataForDisplayDateNew = stateDataForDisplayDate.slice(
  //   3,
  //   stateDataForDisplayDate.length
  // )
  const mappedStateData = stateDataForDisplayDate.map((state, index) => {
    const stateName = states[state[0]]
    return { ...state[1], name: stateName, identifier: state[0] }
  })
  //console.log(mappedStateData[0].forecast_ci_revised_95_overall)
  //forecast_ci_revised_95_overall
  const handleChange = (event) => {
    setSearchFilter(event.target.value)
  }

  let filteredStateData = mappedStateData
  if (searchFilter !== '') {
    // eslint-disable-next-line array-callback-return
    filteredStateData = mappedStateData.filter((cbsa) => {
      if (
        cbsa.name &&
        cbsa.name.toLowerCase().includes(searchFilter.toLowerCase())
      ) {
        return cbsa
      }
    })
  }
  // eslint-disable-next-line array-callback-return
  filteredStateData = filteredStateData.filter((cbsa) => {
    if (cbsa.name && cbsa.name.length > 1) {
      return cbsa
    }
  })

  function showSearch() {
    //console.log(isCancelled);
    isCancelled.current = true
    btnSearchLocation ? setBtnSearchLocation(false) : setBtnSearchLocation(true)
    btnSearchLocation ? setSearchFilter('') : (inputRef.current = false)
    //btnSearchLocation ? inputRef.current.focus() : inputRef.current.focus()
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%', //'95%',
            justifyContent: 'flex-start',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '70%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'graphik',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                  State Incidence
                </h5>
              </span>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '30%',
                justifyContent: 'right',
              }}
            >
              <span onClick={showSearch}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3584 10.8862L18 17.01L17.0701 18L10.3724 11.7859C9.26916 12.7439 8.21615 13.0355 6.64841 13.0355C3.10647 13.0355 0.203247 10.1323 0.203247 6.59032C0.203247 3.04838 3.10647 0.145157 6.64841 0.145157C10.1903 0.145157 13.0936 3.04838 13.0936 6.59032C13.0936 8.36129 12.5197 9.7249 11.3584 10.8862ZM6.78389 1.45483C4.03637 1.45483 1.78389 3.70175 1.78389 6.44249C1.78389 9.20792 4.03637 11.4548 6.78389 11.4548C9.53142 11.4548 11.7839 9.18323 11.7839 6.44249C11.7839 3.70175 9.53142 1.45483 6.78389 1.45483Z"
                    fill="#E40046"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '16px',
              padding: '1rem 0rem 0px',
            }}
          >
            <span style={{ marginLeft: '0px' }}>
              {' '}
              <Tooltip placement="top" iconHeight="15" iconWidth="15">
                <Content maxWidth="300px" fontSize="12px">
                  <p>{aboutText}</p>
                </Content>
              </Tooltip>
            </span>
            &nbsp; Rate represents the incidence of flu within the population in
            a given week. Change indicates the difference in flu incidence since
            the previous week.{' '}
            {/* <b>
              {mappedStateData[3].forecast_ci_revised_95_overall.toLocaleString(
                undefined,
                {
                  maximumFractionDigits: 2,
                }
              ) === 0
                ? 'NA'
                : mappedStateData[3].forecast_ci_revised_95_overall.toLocaleString(
                    undefined,
                    {
                      maximumFractionDigits: 2,
                    }
                  ) + '%'}
            </b> */}
          </div>
          {btnSearchLocation ? (
            <input
              ref={inputRef}
              type="text"
              onChange={handleChange}
              placeholder="Filter States"
            />
          ) : null}
        </div>

        {/* <div
          style={{
            padding: '0rem 0rem',
            paddingBottom: '0.5rem',
            paddingTop: '0.5rem',
            borderTop: '1px solid #424242',
            borderBottom: '1px solid #424242',
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'inline-flex', width: '45%' }}>
            <h4>State</h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '20%',
              justifyContent: 'flex-end',
              cursor: 'pointer',
            }}
          >
            <h4 onClick={() => sortBy(getFilter)}>
              Rate{' '}
              <span style={{ marginLeft: '4px' }}>
                {getVectorImage(getFilter)}
              </span>
            </h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '20%',
              justifyContent: 'flex-end',
            }}
          >
            <h4>Change</h4>
          </div>
          
        </div> */}
        <div
            style={{
              padding: '0rem 0rem',
              paddingBottom: '0.5rem',
              paddingTop: '0.5rem',
              borderTop: '1px solid #CBCCCD',
              borderBottom: '2px solid #002677',
              marginTop: '5px',
            }}
          >
            <div style={{ display: 'inline-flex', width: '44%' }}>
              <h4>State </h4>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '26%',
                justifyContent: 'flex-middle',
                cursor: 'pointer',
              }}
            >
              <h4 onClick={() => sortBy(getFilter)}>
                Rate {getVectorImage(getFilter)}
              </h4>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '30%',
                justifyContent: 'flex-middle',
              }}
            >
              <h4>Change</h4>
            </div>
          </div>
      </div>
      <div style={{ overflowY: 'scroll', height: '100%' }}>
        {filteredStateData
          //.sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((state) => {
            return (
              <StateStat
                state={state}
                chartRef={chartRef}
                key={state.identifier}
                mapOptions={mapOptions}
                toggleEnabled={toggleEnabled}
              />
            )
          })}
      </div>
    </div>
  )
}

export default StateStats
